<template>
  <el-dialog
    width="800px"
    :title="$t('product.imgTranslation')"
    v-model="state.visible"
    align-center
  >
    <div
      class="img-content scrollbar"
      v-loading="state.loading"
      :element-loading-text="$t('product.inTransition')"
    >
      <img :src="state.isTranslation ? state.transLink : state.link" referrerpolicy="no-referrer" />
    </div>
    <div class="footer">
      <el-button type="primary" @click="switchImg">{{ $t('product.originTranslation') }}</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { getTranslationImgUrl } from '@/apis/goods'
import { defineExpose, reactive } from 'vue'

const state = reactive({
  visible: false,
  link: '',
  transLink: '',
  isTranslation: true,
  loading: false,
})

const switchImg = () => {
  state.isTranslation = !state.isTranslation
}

const openModal = (link) => {
  state.isTranslation = true
  state.transLink = ''
  state.visible = true
  state.link = link
  state.loading = true
  getTranslationImgUrl({ url: link })
    .then((res) => {
      state.transLink = res
    })
    .finally(() => {
      state.loading = false
    })
}

defineExpose({
  openModal,
})
</script>

<style lang="scss" scoped>
.img-content {
  max-height: 500px;
  min-height: 500px;
  overflow-y: auto;
  // overflow: hidden;
  img {
    width: 100%;
  }
}

.footer {
  padding-top: 14px;
  display: flex;
  justify-content: flex-end;
}
</style>
